@let localHome = home();

<footer class="inm-footer">
  <div class="inm-footer__inner">
    <div class="inm-footer__brand">
      <img class="inm-footer__logo" src="img/logo.svg" alt="Inmersión Colombia" />

      @if (localHome) {
        <h2 class="inm-footer__title">{{ localHome.home.language.footer_title_one }}</h2>
        <div class="inm-footer__about" [innerHTML]="footerAbout()"></div>
      }

      <div class="inm-footer__social">
        @for (social of socialLinks(); track social.social_networks) {
          <a [href]="social.url" target="_blank" rel="noopener" [attr.aria-label]="social.social">
            @if (social.icon) {
              <img [src]="social.icon" [alt]="social.social" height="20" />
            } @else {
              <i class="{{ social.icon_css }}" aria-hidden="true"></i>
            }
          </a>
        }
      </div>
    </div>

    @if (localHome) {
      <div class="inm-footer__group">
        <h2>{{ localHome.home.language.footer_title_two }}</h2>
        <a target="_blank" rel="noopener" [href]="localHome.home.language.how_work">
          {{ 'como_funciona' | translate }}
        </a>
        <a target="_blank" rel="noopener" [href]="localHome.home.language.credits">
          {{ 'credito_de_contenido' | translate }}
        </a>
        <a routerLink="/pages/privacy-policies/terms-condition">
          {{ 'terms-condition' | translate }}
        </a>
        <a routerLink="/contact">{{ 'navigation.contact' | translate }}</a>
      </div>

      <div class="inm-footer__group">
        <h2>{{ localHome.home.language.footer_title_three }}</h2>
        <a target="_blank" rel="noopener" [href]="localHome.home.language.how_work">
          {{ 'danos_tu_opinion' | translate }}
        </a>
        <a target="_blank" rel="noopener" href="https://www.inmersioncolombia.com">
          www.inmersioncolombia.com
        </a>
      </div>
    }
  </div>

  @if (showPartners() && sortedLogos.length) {
    <div class="inm-footer__partners">
      @for (partner of sortedLogos; track partner.image) {
        <a [href]="partner.url" target="_blank" rel="noopener">
          <img [lazyLoad]="partner.image | cdnUrl: 300 : true" alt="Aliado" />
        </a>
      }
    </div>
  }

  <div class="inm-footer__bottom">
    <span>© {{ currentYear }} Inmersión Colombia</span>
    <span>Desarrollado por CATO</span>
  </div>
</footer>
